import React from 'react'
import { InputWrapper } from '../input/input.style'
import { StyledStepperContainer, StyledStepperWrapper, RadioInputWrapper, AccordionContainer } from './questions-stepper.style'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { IoCheckmarkCircleOutline, IoCheckmarkCircle } from 'react-icons/io5'
import { MdHourglassEmpty } from 'react-icons/md'


const QuestionsStepper = ({ questions, instructions, subjectInfo }) => {
    return (
        <StyledStepperContainer>
            <StyledStepperWrapper>
                <ol className="c-stepper">
                    {questions && questions.map(question => (
                        <li key={question.questionNumber} className="c-stepper__item" data-content={question.questionNumber}>

                            <div className="c-stepper__content">
                                <h3 className="c-stepper__title">Question {question.questionNumber}</h3>
                                <p className="c-stepper__desc" style={{ lineHeight: 1.4 }}>{question.questionText}</p>
                                {question.questionOptions && (<div className='stepper-options'>
                                    {question.questionOptions.map((option, index) => (
                                        <InputWrapper key={index}>
                                            <RadioInputWrapper className=''>
                                                <label class="question-custom-radio-btn">
                                                    <input type="radio" name="radio" />
                                                    {option.optionText}
                                                </label>
                                                {/* <input readOnly className='question-custom-radio-btn' type="radio" checked={option.isCorrect} />
                                                <label>{option.optionText}</label><br /> */}
                                            </RadioInputWrapper>
                                        </InputWrapper>

                                    ))}
                                </div>
                                )}
                            </div>
                        </li>
                    ))}
                    {instructions && instructions.map(instruction => (
                        <li key={instruction.instructionNumber} className="c-stepper__item" data-content={instruction.instructionNumber}>

                            <div className="c-stepper__content">
                                <h3 className="c-stepper__title">{instruction.instructionTitle}</h3>
                                <p className="c-stepper__desc" style={{ lineHeight: 1.4 }}>{instruction.instructionText}</p>
                            </div>
                        </li>
                    ))}
                    {subjectInfo && subjectInfo.map(subjectInfo => (
                        <li key={subjectInfo.subjectInfoNumber} className="c-stepper__item" data-content={subjectInfo.subjectInfoNumber}>

                            <div className="c-stepper__content">
                                <h3 className="c-stepper__title">{subjectInfo.subjectInfoTitle}</h3>
                                <p className="c-stepper__desc" style={{ lineHeight: 1.4 }}>{subjectInfo.subjectInfoText}</p>
                                <AccordionContainer>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <p className='subject-title'>{subjectInfo.subjectTopic}</p>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {subjectInfo.subjectInfoTopics.map(topic => (
                                                <div className="subject-topic-container">
                                                    <div className="subject-topic-main-text">
                                                        <div className="check-icon">
                                                            {topic.isDone ? <IoCheckmarkCircle /> : topic.isQuiz ? <MdHourglassEmpty /> : <IoCheckmarkCircleOutline />}
                                                        </div>

                                                        <p className='subject-topic'>
                                                            {topic.subTopic}
                                                        </p>
                                                    </div>
                                                    <span className='subject-topic-duration'>{topic.duration}</span>
                                                </div>

                                            ))}

                                        </AccordionDetails>
                                    </Accordion>
                                </AccordionContainer>
                            </div>


                        </li>
                    ))}
                </ol>
            </StyledStepperWrapper>

        </StyledStepperContainer>
    )
}

export { QuestionsStepper }
